import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';

interface LoadingState {
  isLoading: boolean;
  pendingRequests: number;
}

const initialState: LoadingState = {
  isLoading: false,
  pendingRequests: 0,
};

const loadingSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading(state) {
      state.pendingRequests += 1;
      state.isLoading = true;
    },
    stopLoading(state) {
      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      if (state.pendingRequests === 0) {
        state.isLoading = false;
      }
    },
  },
});

export const { startLoading, stopLoading } = loadingSlice.actions;

export const selectLoading = (state: RootState) => state.loader.isLoading;

export default loadingSlice.reducer;
